import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {Mental} from "../Mental";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

export class MentalIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xNudge: true,
        xSplit: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    private _bgSprite: PIXI.Sprite;

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBgPortrait", "resources/images/Intro_BG.jpg");
        imgLoader.add("introBgLandscape", "resources/images/Intro_BG1.jpg");
        imgLoader.add("feature1", "resources/images/page1.png");
        imgLoader.add("feature1_US", "resources/images/page1_US.png");
        imgLoader.add("feature2_US", "resources/images/page2_US.png");
        imgLoader.add("feature2", "resources/images/page2.png");
        imgLoader.add("feature3", "resources/images/page3.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    public onResize(): void {
        let textureName: string = "introBgPortrait";
        if (NolimitApplication.isLandscape) {
            textureName = "introBgLandscape";
        }

        this._bgSprite.texture = ImgLoader.getImgTexture(textureName);


    }

    private showUSImage(): string {
        if (Mental.apiPlugin.gameClientConfiguration.showMultipliersInfo) {
            return "";
        } else {
            return "_US";
        }
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBgLandscape"));
        bgSprite.anchor.set(0.5);
        this.background.addChild(bgSprite);
        this._bgSprite = bgSprite;

        this.borderTop = new PIXI.Container();

        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        this.pages = [];
        let page: SlideShowPage;
        let thirdImage: string = "feature3";
        page = new SlideShowPage(ImgLoader.getImgTexture(thirdImage), undefined);
        (page.children[0] as PIXI.Sprite).anchor.set(0.5);
        this.pages.push(page);


        if (Mental.apiPlugin.gameClientConfiguration.isSet) {
            for (let i: number = 2; i > 0; i--) {
                let imgName: string = "feature" + `${(i)}`;
                imgName += this.showUSImage();
                page = new SlideShowPage(ImgLoader.getImgTexture(imgName), undefined);
                (page.children[0] as PIXI.Sprite).anchor.set(0.5);

                this.pages.unshift(page);
            }

            const isNjserver: boolean = !!(Mental.apiPlugin.options && Mental.apiPlugin.options.game && Mental.apiPlugin.options.game.indexOf("NJ") > -1);
            this.stampConfig.xNudge = !isNjserver;

        } else {
            Mental.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                for (let i: number = 2; i > 0; i--) {
                    let imgName: string = "feature" + `${(i)}`;
                    imgName += this.showUSImage();
                    page = new SlideShowPage(ImgLoader.getImgTexture(imgName), undefined);
                    (page.children[0] as PIXI.Sprite).anchor.set(0.5);
                    this.pages.unshift(page);
                }
                const isNjserver: boolean = !!(Mental.apiPlugin.options && Mental.apiPlugin.options.game && Mental.apiPlugin.options.game.indexOf("NJ") > -1);
                this.stampConfig.xNudge = !isNjserver;
            });

        }


    }
}